{
  "zh-TW": {
    "filteredTable": {
      "actions": {
        "unselect": "Unselect all Selected"
      },
      "labels": {
        "selected": "%{count} 已選擇"
      },
      "empty": {
        "info": "我們未找到任何記錄。"
      }
    }
  }
}
